import {
    RequestIdWithWarning,
    replaceRequestId,
    RequestDays,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';
import { DefineDate } from '../../components/utilities/Table/generalColumns/DefineDate';
const commonColumns = [
    RequestIdWithWarning(),
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Celular',
        accessor: 'persona_info_contacto.celular',
    },
    {
        Header: 'Dirección',
        accessor: 'persona_info_contacto.direccion_homologada',
    },
];

const requestsListStatus = [
    {
        id: 'en_proceso_ejecutivo',
        label: 'EN PROCESO',
        status: 20,
        responsable: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));
            cols.splice(2, 0, DefineDate('mesa', 'Fecha Originación'));
            cols.splice(9, 0, {
                Header: 'Seguimiento',
                accessor: 'seguimiento_comercial_novedad.label',
            });
            return cols;
        })(),
        buttonAction: [{ name: 'sendUrlClient' }, { name: 'recordVisit' }],
    },
    {
        id: 'procesadas_ejecutivo',
        label: 'PROCESADAS',
        status: false,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 20,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_ejecutivo',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_rechazo',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
        responsable: false,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols.splice(1, 0, DefineDate('ejecutivo'));

                cols.splice(8, 0, StatusWithTooltip);
                cols.splice(9, 0, CausalRequest);
                cols.splice(10, 0, {
                    Header: 'Seguimiento',
                    accessor: 'seguimiento_comercial_novedad.label',
                });
                return cols;
            })()
        ),
        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
